import React, { Component } from 'react';
import $ from "jquery";

import "./../styles/formTextItem.css";
import ContactService from "../services/Contact.service";

export default class FormTextItem_Contacts extends Component {
    state = {
        name: "",
        phone: "",
        items: [],
        loading: true
    };
    updateName = (e) => {
        this.setState({name: e.target.value});
    };
    updatePhone = (e) => {
        this.setState({phone: e.target.value});
    };
    addItem = async (e) => {
        e.preventDefault();
        const data = {
            name: this.state.name,
            phone: this.state.phone
        }
        const response = await ContactService.post(data);

        if(response.data.message === 'POST_CONTACT_SUCCESSFUL') {
            let newItems = this.state.items;
            newItems.unshift(response.data.item);
            this.setState({ name: "", phone:"", items: newItems });
        } else {
            alert(`Error: ${response.data.message}`);
        }
    }
    removeItem = async (e) => {
        e.preventDefault();
        e.persist();

        const data = {
            UUID: this.state.items[e.target.name].UUID
        }
        const response = await ContactService.delete(data);

        if(response.data.message === 'DELETE_CONTACT_SUCCESSFUL'){
            let newItems = this.state.items;
            newItems.splice(e.target.name, 1);
            this.setState({ items: newItems });
        } else {
            alert(`Error: ${response.data.message}`);
        }
    }

    async componentDidMount(){
        //Sobre el funcionamiento del modal
        var idModals=this.props.idCategory;
        $('#ModalFor'+idModals).css('display', 'block');
        $('#ModalFor'+idModals).hide();

        $('#OpenModal'+idModals).click(function(){
            $('#ModalFor'+idModals).fadeIn();
            $('body').css('overflow-y', 'hidden');
        });

        function closeModal(){
            $('#ModalFor'+idModals).fadeOut(function(){
                $('#textAreaModal'+idModals).val('');
                $('#textAreaModal'+idModals).css('height', '100px');
                $('#CharacterCounter'+idModals).html('0/250');
            });
            $('body').css('overflow-y', 'auto');
        }
        $('#CloseModalA'+idModals).click(closeModal);
        $('#CloseModalB'+idModals).click(closeModal);

        const response = await ContactService.get();
        if (response.status !== 200) {
            alert(`Error: ${response.data.message}`);
        } else {
            this.setState({ loading: false, items: response.data.items });;
        }
    }

    render() {
        var dataReturn;
        if(this.state.items.length>0){
            dataReturn=<div className="itemsList">
                {
                    this.state.items.map((item, index) => {
                        return (
                            <form key={index} className="item" action="">
                                <div className="itemText"><p>{item.name}</p><br/><p>{item.phone}</p></div>
                                <input type="button" onClick={this.removeItem} name={index} value="DEL" id={'DelBTN'+index+'_'+this.props.idCategory}/>
                                <label htmlFor={'DelBTN'+index+'_'+this.props.idCategory} className="btn grey DeleteButton"><i className="material-icons-round">delete</i></label>
                            </form>
                        );
                    })
                }
            </div>
        }else{
            dataReturn=<p className="notFound">No hay ninguna nota para ver, comience escribiendo una.</p>
        }
        var dataLoader=<div className="LoadingContainer">
            <div className="loader"></div>    
        </div>

        return (
            <div className="card formTextItem">
                <h1>{this.props.title}</h1>
                <p className="description">{this.props.description}</p>
                <div className="ButtonAdd">
                    <button className="btn" id={'OpenModal'+this.props.idCategory}><i className="material-icons-round prefix">add</i>Agregar contacto</button>
                </div>

                <div className="modal" id={'ModalFor'+this.props.idCategory}>
                    <div className="modalContent">
                        <form action="" className="card">
                            <div className="body-card">
                                <div className="inputAreaCard">
                                    <input onChange={this.updateName} value={this.state.name} type="text" placeholder="Nombre:" maxLength="50"/>
                                    <input onChange={this.updatePhone} value={this.state.phone} type="text" placeholder="Tel.:" maxLength="30"/>
                                </div>
                            </div>
                            <div className="end-card confirmFooter">
                                <div id={'CloseModalB'+this.props.idCategory}>CANCELAR</div>
                                <button onClick={this.addItem.bind(this)} id={'CloseModalA'+this.props.idCategory} className="btn">LISTO</button>
                            </div>
                        </form>
                    </div>
                </div>

                {this.state.loading ? dataLoader : dataReturn}
            </div>
        )
    }
}
